export const LOADER_METRIC_JOB_EXPERIENCE         =       'LOADER_METRIC_JOB_EXPERIENCE';
export const GET_METRIC_JOB_EXPERIENCE            =       'GET_METRIC_JOB_EXPERIENCE';
export const METRIC_JOB_EXPERIENCE_FALLA          =       'METRIC_JOB_EXPERIENCE_FALLA';
export const SAVE_LOADER_METRIC_JOB_EXPERIENCE    =       'SAVE_LOADER_METRIC_JOB_EXPERIENCE';
export const FORM_METRIC_JOB_EXPERIENCE_FAIL      =       'FORM_METRIC_JOB_EXPERIENCE_FAIL';